import { useRouter } from 'next/router';
import { ModuleContainer } from '../../shared/ModuleContainer';
import OrderDetails from './components/Details/Details';
import OrderDetailsSkeleton from './components/Skeleton';
import { useMyOrderDetails } from '~/services/shop/hooks/mit-fog';

export default function M201OrderDetails() {
    const router = useRouter();
    const orderId = router.query.q;
    const { data, isLoading } = useMyOrderDetails(orderId !== undefined ? orderId.toString() : '');

    return (
        <ModuleContainer spacingTop="none">
            {isLoading || !data ? <OrderDetailsSkeleton /> : <OrderDetails data={data} />}
        </ModuleContainer>
    );
}
